(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 1024;

  function prepareGallery(productRoot) {
    var images = productRoot.querySelector('.product__images');
    if (!images || images.querySelector(':scope > .pickie-r4-gallery-shell')) return images;

    var shell = document.createElement('div');
    shell.className = 'pickie-r4-gallery-shell';

    Array.prototype.slice.call(images.children).forEach(function (child) {
      shell.appendChild(child);
    });

    images.appendChild(shell);
    images.classList.add('pickie-r4-gallery-ready');
    return images;
  }

  function positionProofPanel(panel) {
    var productRoot = panel.closest('[data-product-template]');
    if (!productRoot) return;

    var form = panel.closest('form') || productRoot.querySelector('form[data-product-form]');
    var buttons = form && form.querySelector('.product__form-buttons');
    var images = prepareGallery(productRoot);

    if (window.innerWidth >= DESKTOP_BREAKPOINT && images) {
      images.appendChild(panel);
      panel.setAttribute('data-pickie-r4-position', 'gallery');
    } else if (buttons) {
      buttons.insertAdjacentElement('afterend', panel);
      panel.setAttribute('data-pickie-r4-position', 'purchase');
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-pickie-r4-proof-panel]'), positionProofPanel);
  }

  var resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () { init(document); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  window.addEventListener('resize', onResize, { passive: true });
})();
